import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Mandant } from '../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { SaveForAllDialogComponent } from '../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Injectable({ providedIn: 'root' })
export class SupplierMaterialService {
    constructor(
        private readonly api: KieneTableService,
        private readonly notification: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        public dialog: MatDialog,
    ) {}

    public saveSupplierMaterial(sm: any): void {
        this.loadAvailableMandanten(sm);
    }

    private loadAvailableMandanten(sm: any) {
        if (sm) {
            let params = new HttpParams();
            params = params.append('artikel_id', sm.artikel_id.toString());
            params = params.append('lieferant_id', sm.lieferant_id.toString());
            this.api.get(this.apiBaseUrl + 'artikel_lieferant/read_mandanten.php', params).subscribe({
                next: response => {
                    const availableMandanten: Mandant[] = response.records;

                    if (availableMandanten.length > 1) {
                        this.openSaveForAllDialog(availableMandanten, sm);
                    } else {
                        if (availableMandanten.length === 1) {
                            sm.mandanten_ids = [Number(availableMandanten[0].mandant_id)];
                        }
                        this.saveArtikelLieferant(sm);
                    }
                },
                error: error => {
                    this.notification.errorMessage('Fehler beim Laden der Mandanten', error);
                },
            });
        }
    }

    private openSaveForAllDialog(availableMandanten: Mandant[], sm: any) {
        const dialogRef = this.dialog.open(SaveForAllDialogComponent, {
            data: { availableMandanten: availableMandanten },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const rawIds = Array.isArray(result) ? result : result.mandanten_ids;
                sm.mandanten_ids = (rawIds ?? []).map((id: number | string) => Number(id));
                this.saveArtikelLieferant(sm);
            }
        });
    }

    private saveArtikelLieferant(sm: any) {
        this.api.updateEntity(this.apiBaseUrl + 'artikel_lieferant/update.php', sm).subscribe({
            next: () => {
                this.notification.infoMessage('Artikel-Lieferant erfolgreich editiert!');
            },
            error: error => {
                this.notification.errorMessage('Fehler beim Arikel-Lieferant editieren aufgetreten!', error);
            },
        });
    }
}
